import React, {useState} from 'react'
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Button, Card, Nav, Table } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './cij.css'
import './zartecbutton.css'
import img1 from '../Components/Images/Laser/Fiber Laser.png'
import img2 from '../Components/Images/Laser/Fiber Laser.png'
import img3 from '../Components/Images/applications/Fib1.png'
import img4 from '../Components/Images/applications/Fib2.png'
import img5 from '../Components/Images/applications/Fib3.png'
import img6 from '../Components/Images/applications/Fib4.png'
import img7 from '../Components/Images/applications/Fib5.png'
import img8 from '../Components/Images/applications/Fib6.png'
import img9 from '../Components/Images/applications/Fib7.png'
import img10 from '../Components/Images/applications/Fib8.png'
import img11 from '../Components/Images/applications/Fib9.png'

function Laserfiber() {
    const [activeTab, setActiveTab] = useState('specifications');
    const [activePrinter, setActivePrinter] = useState(null);
    const specsSectionRef = React.useRef(null);

    const specificationData = [
        { label: 'Model', value: 'LT50F - Industrial Fiber Laser Marker' },
        { label: 'Laser Power', value: '50W High-Power Fiber Laser' },
        { label: 'Beam Quality', value: 'M² ≤1.6 (Excellent for precision marking)' },
        { label: 'Pulse Frequency', value: '45-170 kHz (Adjustable for different materials)' },
        { label: 'Laser Wavelength', value: '1064±5 nm (Standard for metal marking)' },
        { label: 'Power Stability', value: '<3% (Consistent performance)' },
        { label: 'Service Life', value: '100,000+ working hours' },
        { label: 'Marking Area', value: '100-300mm (Customizable working range)' },
        { label: 'Max Engraving Depth', value: '1mm (Depends on material and settings)' },
        { label: 'Marking Speed', value: 'Up to 10,000mm/s (High-speed production)' },
        { label: 'Positioning Accuracy', value: '±0.002mm (Precision marking)' },
        { label: 'Min Line Width', value: '0.1mm (Fine detail capability)' },
        { label: 'Min Character Height', value: '0.15mm (Small text readability)' },
        { label: 'Cooling System', value: 'Built-in air cooling (Maintenance-free)' },
        { label: 'Power Requirements', value: '500W / 220V / 50Hz (110V compatible)' },
        { label: 'Operating Environment', value: '0-40°C, 30-85% RH (Industrial conditions)' }
    ];

    const specificationData1 = [
        { label: 'Laser Type', value: '30W Fiber Laser Marking System' },
        { label: 'Model', value: 'LT30F - Compact Fiber Laser' },
        { label: 'Output Power', value: '≥30W (Ideal for most metal marking applications)' },
        { label: 'Laser Wavelength', value: '1064nm (Optimal for metal surfaces)' },
        { label: 'Scanning System', value: 'High precision 2D galvanometer' },
        { label: 'Marking Speed', value: '≤8000 mm/s (Fast production line integration)' },
        { label: 'Control System', value: 'Integrated industrial PC with 10.4" touchscreen' },
        { label: 'Cooling Method', value: 'Air cooled (No water cooling required)' },
        { label: 'Focusing System', value: '190mm double red light focusing' },
        { label: 'Marking Types', value: 'Raster & vector fonts, graphics, barcodes' },
        { label: 'Minimum Line Width', value: '0.1mm (Precision marking capability)' },
        { label: 'Repeat Accuracy', value: '±0.003mm (Consistent quality)' },
        { label: 'Standard Work Area', value: '110×110mm (Larger areas available)' },
        { label: 'Positioning System', value: 'Dual red light alignment' },
        { label: 'Line Speed Capacity', value: '0-200m/min (Production line compatible)' },
        { label: 'Power Consumption', value: '500W (Energy efficient operation)' }
    ];

    const applicationData=[
        {id:1, image:img3, alt:'Fiber laser marking on paper packaging'},
        {id:2, image:img4, alt:'Permanent laser engraving on metal cans'},
        {id:3, image:img5, alt:'Plastic product serialization with fiber laser'},
        {id:4, image:img6, alt:'Industrial metal parts identification marking'},
        {id:5, image:img7, alt:'High-contrast plastic container coding'},
        {id:6, image:img8, alt:'Beverage can laser marking system'},
        {id:7, image:img9, alt:'Food can traceability laser engraving'},
        {id:8, image:img10, alt:'Metal container production date marking'},
        {id:9, image:img11, alt:'Precision metal component serial numbering'},
    ];

    const handleProductClick = (printerId) => {
        setActivePrinter(printerId);
        setActiveTab('specifications');

        setTimeout(() => {
            specsSectionRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }, 50);
    };

    const printers = [
        {
            id: 1,
            model: "ZAR Fiber Laser - 50W",
            description: "Industrial 50W fiber laser marking machine for high-speed permanent marking on metals, plastics, and packaging. Ideal for barcodes, serial numbers, and product identification in demanding manufacturing environments.",
            image: img1,
            specifications: {
                keyFeatures: [
                    {
                        title: "Industrial-Grade Performance",
                        features: [
                            "50W fiber laser source for deep, permanent marks",
                            "Maintenance-free operation with 100,000+ hour lifespan",
                            "IP54 rated for harsh industrial environments",
                            "No consumables - environmentally friendly solution"
                        ]
                    },
                    {
                        title: "Precision Marking Capabilities",
                        features: [
                            "±0.002mm repeat accuracy for consistent quality",
                            "0.1mm minimum line width for detailed markings",
                            "Supports text, logos, barcodes, and 2D codes"
                        ]
                    },
                    {
                        title: "High-Speed Production Ready",
                        features: [
                            "Up to 10,000mm/s marking speed",
                            "Handles production line speeds up to 200m/min",
                            "Large 300mm working area option available"
                        ]
                    },
                    {
                        title: "User-Friendly Operation",
                        features: [
                            "Intuitive 10.4\" touchscreen interface",
                            "Multi-language support including Arabic/English",
                            "Easy integration with existing production lines"
                        ]
                    }
                ],
                technical: specificationData,
                applications: applicationData
            }
        },
        {
            id: 2,
            model: "ZAR Fiber Laser - 30W",
            description: "Compact 30W fiber laser marking system perfect for metal engraving, plastic marking, and product serialization. Offers reliable, maintenance-free operation for industrial traceability applications.",
            image: img2,
            specifications: {
                keyFeatures: [
                    {
                        title: "Reliable Marking Solution",
                        features: [
                            "30W fiber laser for crisp, permanent marks",
                            "No inks or solvents required - clean operation",
                            "IP54 protection against dust and moisture"
                        ]
                    },
                    {
                        title: "High Quality Marking",
                        features: [
                            "0.1mm precision for detailed engravings",
                            "Excellent for UID, serial numbers, and logos",
                            "Creates tamper-proof marks for anti-counterfeiting"
                        ]
                    },
                    {
                        title: "Production Efficiency",
                        features: [
                            "8000mm/s marking speed for fast throughput",
                            "Red light positioning for quick setup",
                            "Compatible with automated production lines"
                        ]
                    },
                    {
                        title: "Easy Integration",
                        features: [
                            "Compact footprint fits in tight spaces",
                            "Simple touchscreen operation",
                            "Supports common industrial protocols"
                        ]
                    }
                ],
                technical: specificationData1,
                applications: applicationData
            }
        }
    ];

    const renderKeyFeatures = (features) => {
        return features.map((group, index) => (
            <div key={index} style={{ marginBottom: '20px' }}>
                <h5 style={{ color: '#00663b', marginBottom: '10px' }}>{group.title}</h5>
                <ul style={{ listStyle: 'none', paddingLeft: '20px' }}>
                    {group.features.map((feature, i) => (
                        <li key={i} style={{ position: 'relative', paddingLeft: '25px', marginBottom: '8px' }}>
                            <span style={{ 
                                position: 'absolute', 
                                left: 0,
                                color: '#00663b',
                                fontWeight: 'bold',
                                fontSize: '17px',
                            }}>•</span>
                            {feature}
                        </li>
                    ))}
                </ul>
            </div>
        ));
    };

    const renderTabContent = () => {
        if (!activePrinter) return <div className="p-5 text-center">Please select a printer to view details</div>;
        
        const printer = printers.find(p => p.id === activePrinter);
        if (!printer) return null;
        
        switch (activeTab) {
            case 'specifications':
                return (
                    <div style={{ padding: '20px' }}>
                        <h4 style={{ marginTop: '10px', marginBottom: '20px' }}>Key Features</h4>
                        {renderKeyFeatures(printer.specifications.keyFeatures)}
                    </div>
                );
            case 'features':
                return (
                    <div style={{ padding: '20px' }}>
                        <h4 style={{ marginTop: '10px', marginBottom: '20px' }}>Technical Specifications</h4>
                        <Table bordered hover responsive>
                            <tbody>
                                {printer.specifications.technical.map((item, index) => (
                                    <tr key={index}>
                                        <td className="bg-light" style={{ width: '30%', fontWeight: 'bold' }}>{item.label}</td>
                                        <td>{item.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                );
            case 'applications':
                return (
                    <div style={{ padding: '20px' }}>
                        <h4 style={{ marginTop: '10px', marginBottom: '20px' }}>Industrial Applications</h4>
                        <div className="row g-4">
                            {printer.specifications.applications.map((app) => (
                            <div key={app.id} className="col-md-6 col-lg-4 pb-5">
                                <div className="card h-100 app-card shadow-sm">
                                <img 
                                    src={app.image} 
                                    className="card-img-top" 
                                    alt={app.alt}
                                    style={{ height: '200px', objectFit: 'cover' }}
                                    loading="lazy"
                                />
                                <div className="card-body">
                                    <h5 className="card-title text-center" style={{fontSize:"15px"}}>{app.alt}</h5>
                                </div>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <Helmet>
                <title>Fiber Laser Marking Machines | Industrial Metal & Plastic Engraving Systems</title>
                <meta name="description" content="Professional fiber laser marking machines for permanent engraving on metals, plastics, and packaging. 30W and 50W models available for industrial traceability, barcoding, and product identification." />
                <meta name="keywords" content="fiber laser marking machine, metal engraving laser, industrial laser marking, plastic marking laser, product serialization, barcode laser engraver, permanent marking system, laser coding machine, UID marking, industrial traceability" />
                <meta property="og:title" content="Industrial Fiber Laser Marking Machines | ZAR Laser Systems" />
                <meta property="og:description" content="High-performance fiber laser solutions for permanent product marking and industrial identification" />
                <link rel="canonical" href="https://www.yourwebsite.com/fiber-laser-marking" />
            </Helmet>

            <section>
                <Container className="py-5">
                    <h1 className="mb-4 cijh2">Industrial Fiber Laser Marking Systems</h1>
                    <p className="lead mb-4">High-performance fiber laser machines for permanent marking on metals, plastics, and industrial materials. Our systems provide maintenance-free operation for product identification, traceability, and anti-counterfeiting applications.</p>
                    <Row>
                        {printers.map(printer => (
                            <Col lg={4} md={6} className="mb-4" key={printer.id}>
                                <Card 
                                    className={`h-100 border-light shadow-sm rounded-3 ${activePrinter === printer.id ? 'border-primary' : ''}`}
                                    onClick={() => setActivePrinter(printer.id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <Card.Body className="d-flex flex-column">
                                        <div className="mb-2" 
                                            style={{
                                                background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                                                WebkitBackgroundClip: "text",
                                                backgroundClip: "text",
                                                color: "transparent",
                                                fontWeight: "bold",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                textDecoration: "none",
                                                marginTop: "auto",
                                            }}>
                                            {printer.model}
                                        </div>
                                        <p className="text-muted">{printer.description}</p>
                                        <button 
                                            className="zartec-btn zartec-btn-primary zartec-btn-small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleProductClick(printer.id);
                                            }}
                                        >
                                            View Details
                                        </button>
                                    </Card.Body>
                                    <div className="p-3 text-center">
                                        <img 
                                            src={printer.image} 
                                            alt={`${printer.model} - Industrial fiber laser marking system`} 
                                            className="img-fluid" 
                                            style={{ maxHeight: '200px' }} 
                                            loading="lazy"
                                        />
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
            
            {activePrinter && (
                <section ref={specsSectionRef}>
                    <div className="product-navbar-container mb-4">
                        <Nav className="nav-tabs-custom d-flex justify-content-center">
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link 
                                    className={`px-4 py-3 ${activeTab === 'specifications' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('specifications')}
                                >
                                    <span className="nav-text">Key Features</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link 
                                    className={`px-4 py-3 ${activeTab === 'features' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('features')}
                                >
                                    <span className="nav-text">Technical Specifications</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link 
                                    className={`px-4 py-3 ${activeTab === 'applications' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('applications')}
                                >
                                    <span className="nav-text">Industry Applications</span>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <div className="border border-top-0 p-0 bg-white">
                        {renderTabContent()}
                    </div>
                </section>
            )}
        </div>
    );
}

export default Laserfiber;